
import { defineComponent } from 'vue'
import JrInputView from '@/components/jr-parts/JrInputView.vue'
import DateDisplay from '@/components/displays/DateDisplay.vue'

export default defineComponent({
  name: 'JrDatePicker',
  emits: ['update:modelValue'],
  components: {
    JrInputView,
    DateDisplay,
  },
  props: {
    modelValue: {
      type: String,
      required: false,
      default: null,
    },
    format: {
      type: String,
      required: false,
      default: 'YYYY年MM月DD日',
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    return {
      update: (inputDate: Date | null) => {
        if (inputDate == null) {
          context.emit('update:modelValue', '')
          return
        }
        // YYYY-MM-DD形式に変換する
        const year = inputDate.getFullYear()
        const month = ('00' + (inputDate.getMonth() + 1)).slice(-2)
        const date = ('00' + inputDate.getDate()).slice(-2)
        context.emit('update:modelValue', `${year}-${month}-${date}`)
      },
    }
  },
})
